import React from 'react';
import Content from '@/components/foundations/content';
import { StaticImage } from 'gatsby-plugin-image';
import * as styles from './ourClients.module.scss';

const OurClientsContent: React.FC = () => {
  return (
    <>
      <div className={styles.oOurClients}>
        <h2>
          <span>
            <strong>Our Clients</strong>
            <small>ご提供実績</small>
          </span>
        </h2>
        <h3>SaaS、ECサイト、基幹システム等、様々なプロタクトやサービスに対する実績がございます。</h3>
        <ul>
          <li>
            <p>株式会社オークネットさま</p>
          </li>
          <li>
            <p>ソフトバンク株式会社さま</p>
          </li>
          <li>
            <p>株式会社ベネッセコーポレーションさま</p>
          </li>
          <li>
            <p>株式会社パソナさま</p>
          </li>
        </ul>
        <ul className={styles.more}> 
          <li>
            <figure>
              <StaticImage src="./img/three_dots.svg" alt="" />
            </figure>
            <p>and more!</p>
          </li>
        </ul>
      </div>
    </>
  );
};

const OurClients: React.FC = () => {
  return (
    <Content
      className={{ wrapper: styles.oOurClients, inner: styles.lContent__inner }}
      intersection={{ visible: styles.visible, standby: styles.standby }}
    >
      <OurClientsContent />
    </Content>
  );
};

export default OurClients;
